<template>
  <div class="content_w_710" :id="content.key">
    <component :is="componentsName[content.type]" :content="content" :canSetWidth="true"></component>
    
    <!-- <imageUnit v-for="item in content.content" :key="item.key" :content="item" :canSetWidth="true"></imageUnit> -->
  </div>
</template>

<script>
/*
板式-3 集合展示
*/
import imageUnit from "../unit/image-collection.vue";
import videoUnit from "../unit/video-collection.vue";
import audioUnit from "../unit/audio-collection.vue";
import threeDUnit from "../unit/three-D-collection.vue";
export default {
  name: "mediaTemplate3",
  components: {
    imageUnit,
    videoUnit,
    audioUnit,
    threeDUnit,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      componentsName: {
        'image': 'imageUnit',
        'video': 'videoUnit',
        'audio': 'audioUnit',
        '3DModel': 'threeDUnit',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 0 auto 20px;
}
</style>